import React from "react";
import HubspotFieldTypes from "constants/hubspot-field-types";
import { FormTextInput } from "../form-input/form-text-input";
import { FormTextArea } from "../form-textarea/form-textarea";
import { FormSelect } from "../form-select/form-select";
import { CollectionUtils } from "andculturecode-javascript-core";
import { UseHubspotStateProps } from "./use-hubspot-form";
import { t } from "utilities/localization/t";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface HubspotFormProps extends Partial<UseHubspotStateProps> {}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME: string = "hubspot-form";

const FIELD_TYPE_TO_FIELD_COMPONENT_MAP: Record<HubspotFieldTypes, React.FC<any>> = {
    [HubspotFieldTypes.Text]: FormTextInput,
    [HubspotFieldTypes.TextArea]: FormTextArea,
    [HubspotFieldTypes.Select]: FormSelect,
    [HubspotFieldTypes.Number]: FormTextInput,
    [HubspotFieldTypes.PhoneNumber]: FormTextInput,
};

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const HubspotForm: React.FC<HubspotFormProps> = ({
    fields,
    fieldValueMap,
    formErrors,
    onFieldChange,
}: HubspotFormProps) => {
    return (
        <div className={CSS_CLASS_NAME}>
            {CollectionUtils.hasValues(fields) &&
                fields?.map((field) => {
                    const Component = FIELD_TYPE_TO_FIELD_COMPONENT_MAP[field.fieldType];
                    const isValid = CollectionUtils.isEmpty(formErrors?.[field.name]);
                    const errors = formErrors?.[field.name];

                    const options = field.options?.map((o: { label: string; value: string }) => ({
                        ...o,
                        text: o.label,
                    }));

                    const { type: _, ...cleanedField } = field.toObject();

                    return (
                        <Component
                            isValid={isValid}
                            errorMessages={errors}
                            {...cleanedField}
                            dataTestId={`hubspot-form--${field.type}--${field.name}`}
                            label={field.label}
                            id={field.name}
                            name={field.name}
                            options={[
                                {
                                    value: "",
                                    isPlaceholder: true,
                                    text: t("selectAnOption"),
                                },
                                ...(options ?? []),
                            ]}
                            required={field.required}
                            formFieldName={field.name}
                            value={fieldValueMap?.[field.name as keyof typeof fieldValueMap]}
                            key={field.name}
                            onChange={(e: any) => onFieldChange!(field.name, e)}
                        />
                    );
                })}
        </div>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { HubspotForm };

// #endregion Exports
